// @flow

import { cmsActions } from './cmsActionCreator';
const today = new Date();
const sevenDaysBack = new Date();
sevenDaysBack.setDate(today.getDate() - 7);

const initialState = {
  pageNumber: 0,
  pageSize: 10,
  isLoadingData: false,
  csv: {},
  emails: [],
  emailsCount: {
    ZOOM_RETAIL: 0,
    ZOOM_FRANCHISE: 0,
    ZOOM_CORPORATE: 0
  },
  isLoading: false,
  emailData: {
    id: null,
    to: [],
    cc: [],
    // bcc: [],
    clientGroup: [],
    subject: null,
    content: '',
    attachmentsDTO: null
  },
  allMailsData: {},
  isModalDataLoading: false,
  filters: {
    requestStatus: null,
    startDate: today,
    endDate: sevenDaysBack
  }
};

const cmsReducer = (state = initialState, action) => {
  switch (action.type) {
    case cmsActions.GET_ALL_MAILS: {
      return Object.assign({}, state, action.payload);
    }
    case cmsActions.SET_MODAL_LOADER: {
      return { ...state, isModalDataLoading: action.payload };
    }
    case cmsActions.SET_IS_LOADING_DATA: {
      return { ...state, isLoadingData: action.payload };
    }
    case cmsActions.UPDATE_PAGE_NUMBER: {
      return { ...state, pageNumber: action.payload };
    }
    case cmsActions.GET_EMAILS: {
      return {
        ...state,
        emails: action.payload.emails,
        emailsCount: action.payload.emailsCount
      };
    }
    case cmsActions.GET_DETAILED_EMAIL: {
      return { ...state, detailedEmail: action.payload };
    }
    case cmsActions.DOWNLOAD_CSV: {
      return { ...state, csv: action.payload };
    }
    case cmsActions.UPDATE_FILTER_FIELDS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      });
    }
    case cmsActions.SET_EMAIL_DATA: {
      return Object.assign({}, state, {
        emailData: { ...state.emailData, ...action.payload }
      });
    }
    case cmsActions.SET_DRAFT_RESPONSE: {
      return { ...state, emailData: action.payload };
    }
    case cmsActions.RESET_EMAIL_DATA: {
      return Object.assign({}, state, {
        emailData: { ...state.emailData, ...initialState.emailData }
      });
    }

    default: {
      return state;
    }
  }
};

export default cmsReducer;
